@if(!review){
<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Certificación de Procedimientos</li>
</ol>

<h1 class="page-header"><i class="fas fa-tachometer-alt"></i> Certificación de Procedimientos</h1>
}

<app-evaluation-certpro [period]="period" [entity]="entity ? {id: entity} : null" [review]="review" (backEvent)="back()"></app-evaluation-certpro>